import { useMutation, useQueryClient } from "react-query";
import { Auth } from "../../interface";
import { mutateDeleteFn } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useDeleteKeyHostUser = () => {
  const queryClient = useQueryClient();
  return useMutation<Auth, never, any>(
    (data) => mutateDeleteFn(ENDPOINTS.DELETE_KEY_HOST_USER, data),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(["keyHostDetails"]);
      },
    }
  );
};